import type { CSSProperties, HTMLAttributes } from "react";

import "./skeleton.css";
import { cn } from "./cn";

export type SkeletonVariant = "text" | "rect" | "circle";

export interface SkeletonProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: SkeletonVariant;
  width?: number | string;
  height?: number | string;
}

const toDim = (v: number | string): string => (typeof v === "number" ? `${v}px` : v);

/**
 * Loading placeholder. Decorative (`aria-hidden`) — announce loading on the surrounding
 * region with `aria-busy`. Shimmer is disabled under `prefers-reduced-motion`.
 */
export function Skeleton({
  variant = "text",
  width,
  height,
  className,
  style,
  ...rest
}: SkeletonProps) {
  const dim: CSSProperties = {
    ...(width !== undefined ? { width: toDim(width) } : null),
    ...(height !== undefined ? { height: toDim(height) } : null),
    ...style,
  };
  return (
    <span
      aria-hidden="true"
      className={cn("rc-skeleton", `rc-skeleton--${variant}`, className)}
      style={dim}
      {...rest}
    />
  );
}
